enum DefaultChartColorsEnum {
  blue = '#1677FF',
  green = '#73D13D',
  orange = '#FFD666',
  red = '#FF4D4F',
  aquamarine = '#36CFC9',
  pink = '#B37FEB',
  redDark = '#c23531',
  greyDark = '#2f4554',
  blueDark = '#61a0a8',
  redGrey = '#d48265',
  greenGrey = '#91c7ae',
  greenDark = '#055e24',
  yellowDark = '#ca8622',
  redLight = '#bda29a',
  grey = '#6e7074',
  greyLight = '#546570',
  whiteDark = '#c4ccd3',
}

export const defaultChartColors = Object.values(DefaultChartColorsEnum);
